export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Wip 1_00.9967a994.jpg";